<template>
  <v-dialog v-model="openDialog" width="1200px" class="dialog">
    <v-card>
      <v-card-title>
        <span>Logs de navegação</span>
      </v-card-title>
      <v-card-subtitle class="pt-3">
        <span class="description-label"
          >A plataforma Mercafacil registra todas as páginas e rotas acessadas por um usuário. Este relatório pode ser utilizado para acompanhar o histórico de
          navegação do usuário, visando transparência e segurança do sistema.</span
        >
      </v-card-subtitle>
      <v-card-text>
        <paginated-data-table
          :query="query"
          :queryVariables="queryVariables"
          :headers="headers"
          :search="search"
          internal-search
          use-export-csv
          :csv-filename="`navigation_logs_${userId}`"
          :get-csv-data-shape="getCsvDataShape"
          :csv-headers="csvHeaders"
          :csv-rows="csvRows"
          export-all-result
          :export-all-result-incremental-page-size="100"
          query-name="platformUserTracks"
        >
          <template #item="{ item }">
            <tr>
              <td>{{ getRouteTitle(item.genericRoute) }}</td>
              <td>{{ item.route }}</td>
              <td>{{ item.createdAt | date({ fmtIn: 'iso' }) }}</td>
            </tr>
          </template>
        </paginated-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <mf-button class="pr-3" label="Fechar" outlined @click="openDialog = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { QUERY_GET_NAVIGATION_LOGS } from '@/modules/usuarios/graphql'
import date from '@/filters/date'
export default {
  name: 'NavigationLogsModal',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    search: '',
  }),
  computed: {
    openDialog: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.$emit('input', newValue)
      },
    },
    query() {
      return QUERY_GET_NAVIGATION_LOGS
    },
    queryVariables() {
      return {
        userId: this.userId,
      }
    },
    headers() {
      return [
        { text: 'Página', value: 'genericRoute' },
        { text: 'Rota', value: 'route' },
        { text: 'Data e hora', value: 'createdAt' },
      ]
    },
    csvHeaders() {
      return this.headers.map((header) => header.text)
    },
    csvRows() {
      return this.headers.map((header) => header.value)
    },
  },
  methods: {
    getRouteTitle(routePath) {
      const resolved = this.$router.resolve(routePath)
      return resolved.route.meta?.title || '-'
    },
    getCsvDataShape(item) {
      return {
        genericRoute: this.getRouteTitle(item.genericRoute),
        route: item.route,
        createdAt: date(item.createdAt, { fmtIn: 'iso', fmtOut: 'dd/MM/yyyy HH:mm:ss' }),
      }
    },
  },
}
</script>
